import { questions } from "../../../constants/homeQuestions";
import FaqArticle from "../../faq/components/FaqArticle";
import Button from "../../../components/ui/buttons/Button";

const Questions = () => {
    return <section>
        <h2 className="base-h2-secondary mb-12">Vous avez des questions ?</h2>
        <div className={"w-10/12 mx-auto mb-10"}>
            {questions.length > 0 &&
                questions.map((article, index) => {
                    return <FaqArticle
                        article={article}
                        key={`article-home-${index}`}
                        type={'preteur'}
                    />
                })
            }
        </div>
        <Button
            text="Accéder à la FAQ"
            link={{ href: "/preter/faq-preteur", external: false }}
            tailwinClass="mx-auto !block w-fit mb-10"
            btnType="secondary"
            hover={true}
        />
    </section>
}

export default Questions;